import InternalBankOfTalents from './InternalBankOfTalents';

export default InternalBankOfTalents;
